import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarDismiss,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { RxSnackbarComponent } from 'libs/rx-ui/src/lib/rx-snackbar/rx-snackbar.component';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  actionButtonLabel = 'Retry';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(public snackBar: MatSnackBar) {}

  public notify(error: any, i?: number): Observable<MatSnackBarDismiss> {
    const config = new MatSnackBarConfig();
    config.verticalPosition = this.verticalPosition;
    config.horizontalPosition = this.horizontalPosition;
    config.duration = 10000;
    config.panelClass = ['test'];
    const errorMsg = error.message ? error.message : error;
    config.data = {
      text: errorMsg,
      dismissText: 'Error',
    };

    return this.snackBar.openFromComponent(RxSnackbarComponent, config).afterDismissed();
  }
}
